import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wallet-drawer",
  role: "dialog",
  "aria-label": "Wallet"
}
const _hoisted_2 = { class: "drawer-header" }
const _hoisted_3 = { class: "balance-amount mono" }
const _hoisted_4 = {
  key: 0,
  class: "spinner"
}
const _hoisted_5 = { class: "conn-text" }
const _hoisted_6 = {
  key: 1,
  class: "boarding-status"
}
const _hoisted_7 = { class: "drawer-tabs" }
const _hoisted_8 = { class: "drawer-body" }
const _hoisted_9 = {
  key: 0,
  class: "section-body"
}
const _hoisted_10 = { class: "recv-block" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "input-row" }
const _hoisted_13 = ["min", "max", "disabled"]
const _hoisted_14 = ["disabled", "title"]
const _hoisted_15 = {
  key: 0,
  class: "hint"
}
const _hoisted_16 = {
  key: 1,
  class: "hint"
}
const _hoisted_17 = {
  key: 1,
  class: "swap-result"
}
const _hoisted_18 = { class: "mono" }
const _hoisted_19 = { class: "recv-block" }
const _hoisted_20 = { class: "mono" }
const _hoisted_21 = {
  key: 0,
  class: "address-action"
}
const _hoisted_22 = { class: "recv-block" }
const _hoisted_23 = { class: "mono" }
const _hoisted_24 = {
  key: 0,
  class: "address-action"
}
const _hoisted_25 = {
  key: 0,
  class: "boarding-list"
}
const _hoisted_26 = { class: "mono" }
const _hoisted_27 = { class: "text-muted boarding-conf" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 1,
  class: "section-body"
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "detect-row"
}
const _hoisted_33 = {
  key: 0,
  class: "hint"
}
const _hoisted_34 = {
  key: 1,
  class: "input-row"
}
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 2,
  class: "status-badge pending"
}
const _hoisted_37 = {
  key: 3,
  class: "status-badge error"
}
const _hoisted_38 = ["disabled", "title"]
const _hoisted_39 = {
  key: 4,
  class: "hint error-hint"
}
const _hoisted_40 = {
  key: 5,
  class: "hint error-hint"
}
const _hoisted_41 = {
  key: 1,
  class: "swap-result"
}
const _hoisted_42 = { class: "status-badge success" }
const _hoisted_43 = {
  key: 2,
  class: "activity-section"
}
const _hoisted_44 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_45 = {
  key: 1,
  class: "tx-list"
}
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "tx-body" }
const _hoisted_49 = { class: "tx-top" }
const _hoisted_50 = { class: "tx-label" }
const _hoisted_51 = {
  key: 0,
  class: "tx-badge boarding"
}
const _hoisted_52 = { class: "tx-bottom" }
const _hoisted_53 = { class: "tx-time text-muted" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 3,
  class: "settings-section"
}
const _hoisted_56 = ["disabled"]
const _hoisted_57 = { class: "server-info text-muted mono" }
const _hoisted_58 = { class: "modal-card casino-card-glow" }
const _hoisted_59 = { class: "mono" }
const _hoisted_60 = { class: "modal-card casino-card-glow" }
const _hoisted_61 = { class: "modal-actions" }
const _hoisted_62 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "drawer-overlay" }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "drawer-backdrop",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "drawer" }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("aside", _hoisted_1, [
              _createElementVNode("header", _hoisted_2, [
                _createElementVNode("div", null, [
                  _cache[31] || (_cache[31] = _createElementVNode("div", { class: "balance-eyebrow" }, "YOUR BALANCE", -1)),
                  _createElementVNode("div", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_ctx.store.getters['ark/formattedBalance'] || '0') + " ", 1),
                    _cache[30] || (_cache[30] = _createElementVNode("span", { class: "balance-unit" }, "sats", -1))
                  ])
                ]),
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                  "aria-label": "Close"
                }, "×")
              ]),
              (_ctx.arkStatus !== 'connected')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["conn-banner", _ctx.arkStatus])
                  }, [
                    (_ctx.arkStatus === 'connecting')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(["dot", _ctx.arkStatus])
                        }, null, 2)),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.connText), 1),
                    (_ctx.arkStatus === 'error' || _ctx.arkStatus === 'disconnected')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "btn-outline btn-xs",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reconnect && _ctx.reconnect(...args)))
                        }, " Retry "))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.boardingBalance > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _cache[32] || (_cache[32] = _createElementVNode("span", { class: "boarding-dot" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.boardingBalance.toLocaleString()) + " sats boarding ", 1),
                    _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-muted" }, "— settling into Ark", -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: _normalizeClass(['tab', { active: _ctx.tab === 'receive' }]),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tab = 'receive'))
                }, "Receive", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(['tab', { active: _ctx.tab === 'send' }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tab = 'send'))
                }, "Send", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(['tab', { active: _ctx.tab === 'activity' }]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tab = 'activity'))
                }, "Activity", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(['tab', { active: _ctx.tab === 'settings' }]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.tab = 'settings'))
                }, "Settings", 2)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.tab === 'receive')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "block-label" }, "⚡ Lightning", -1)),
                        (!_ctx.depositInvoice)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "input",
                                  type: "number",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.depositAmount) = $event)),
                                  placeholder: "Amount in sats",
                                  min: _ctx.limits?.min,
                                  max: _ctx.limits?.max,
                                  disabled: !_ctx.ready
                                }, null, 8, _hoisted_13), [
                                  [
                                    _vModelText,
                                    _ctx.depositAmount,
                                    void 0,
                                    { number: true }
                                  ]
                                ]),
                                _createElementVNode("button", {
                                  class: "btn-primary btn-sm",
                                  disabled: !_ctx.depositAmount || _ctx.depositLoading || !_ctx.ready,
                                  title: !_ctx.ready ? 'Connecting to Ark…' : '',
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.createLnDeposit && _ctx.createLnDeposit(...args)))
                                }, _toDisplayString(_ctx.depositLoading ? 'Creating…' : 'Invoice'), 9, _hoisted_14)
                              ]),
                              (_ctx.depositAmount && _ctx.fees)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _cache[34] || (_cache[34] = _createTextVNode(" You receive ≈ ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(_ctx.calcReceive(_ctx.depositAmount).toLocaleString()), 1),
                                    _cache[35] || (_cache[35] = _createTextVNode(" sats after fees ", -1))
                                  ]))
                                : (_ctx.fees && _ctx.limits)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.limits.min.toLocaleString()) + " – " + _toDisplayString(_ctx.limits.max.toLocaleString()) + " sats · " + _toDisplayString(_ctx.fees.reverse.percentage) + "% + " + _toDisplayString((_ctx.fees.reverse.minerFees.lockup + _ctx.fees.reverse.minerFees.claim).toLocaleString()) + " fee ", 1))
                                  : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["status-badge", _ctx.depositStatus])
                              }, _toDisplayString(_ctx.depositStatusText), 3),
                              _createElementVNode("div", {
                                class: "address-box",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.copyText(_ctx.depositInvoice)))
                              }, [
                                _createElementVNode("code", _hoisted_18, _toDisplayString(_ctx.depositInvoice), 1),
                                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "address-action" }, "Click to copy", -1))
                              ]),
                              _createElementVNode("button", {
                                class: "btn-outline btn-sm",
                                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.resetDeposit && _ctx.resetDeposit(...args)))
                              }, "New Invoice")
                            ]))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[38] || (_cache[38] = _createElementVNode("div", { class: "block-label" }, "Ark address", -1)),
                        _createElementVNode("div", {
                          class: "address-box",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.copyText(_ctx.arkAddress)))
                        }, [
                          _createElementVNode("code", _hoisted_20, _toDisplayString(_ctx.arkAddress || (_ctx.ready ? '—' : 'Connecting…')), 1),
                          (_ctx.arkAddress)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Click to copy"))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.isMutinyTestnet && _ctx.ready)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn-outline btn-sm",
                              onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.requestFaucet && _ctx.requestFaucet(...args)))
                            }, " Request Testnet Faucet "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "block-label" }, "On-chain", -1)),
                        _createElementVNode("div", {
                          class: "address-box",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.copyText(_ctx.boardingAddress)))
                        }, [
                          _createElementVNode("code", _hoisted_23, _toDisplayString(_ctx.boardingAddress || (_ctx.ready ? '—' : 'Connecting…')), 1),
                          (_ctx.boardingAddress)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Click to copy"))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.boardingUtxos.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boardingUtxos, (utxo) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: utxo.outpoint.txid + ':' + utxo.outpoint.vout,
                                  class: "boarding-item"
                                }, [
                                  _cache[39] || (_cache[39] = _createElementVNode("span", { class: "boarding-dot" }, null, -1)),
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(Number(utxo.amount).toLocaleString()) + " sats", 1),
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(utxo.confirmations ? utxo.confirmations + ' conf' : 'unconfirmed'), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.hasUnsettledFunds && _ctx.ready)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "btn-primary btn-sm",
                              disabled: _ctx.settleLoading,
                              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.settleFunds && _ctx.settleFunds(...args)))
                            }, _toDisplayString(_ctx.settleLoading ? 'Settling…' : 'Settle Into Ark'), 9, _hoisted_28))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'send')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                      (_ctx.sendStatus !== 'success')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _withDirectives(_createElementVNode("textarea", {
                              class: "input send-input",
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.sendInput) = $event)),
                              rows: "2",
                              disabled: !_ctx.ready,
                              placeholder: "Paste a Lightning invoice, Ark address, or Bitcoin address"
                            }, null, 8, _hoisted_31), [
                              [_vModelText, _ctx.sendInput]
                            ]),
                            (_ctx.sendInput.trim())
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["detect-chip", _ctx.sendDetected.kind])
                                  }, _toDisplayString(_ctx.sendKindLabel), 3),
                                  (_ctx.sendDetected.kind === 'lightning' && _ctx.sendDetected.amountSats > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.sendDetected.amountSats.toLocaleString()) + " sats ", 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.sendNeedsAmount)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "input",
                                    type: "number",
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.sendAmount) = $event)),
                                    placeholder: "Amount (sats)",
                                    min: "0",
                                    disabled: !_ctx.ready
                                  }, null, 8, _hoisted_35), [
                                    [
                                      _vModelText,
                                      _ctx.sendAmount,
                                      void 0,
                                      { number: true }
                                    ]
                                  ]),
                                  _createElementVNode("button", {
                                    class: "btn-outline btn-sm",
                                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.sendSetMax && _ctx.sendSetMax(...args)))
                                  }, "MAX")
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.sendStatus === 'pending')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.sendStatusText), 1))
                              : (_ctx.sendStatus === 'error')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.sendStatusText), 1))
                                : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              class: "btn-primary",
                              disabled: !_ctx.canSend,
                              title: !_ctx.ready ? 'Connecting to Ark…' : '',
                              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.doSend && _ctx.doSend(...args)))
                            }, _toDisplayString(_ctx.sendLoading ? 'Sending…' : _ctx.sendButtonLabel), 9, _hoisted_38),
                            (_ctx.sendInput.trim() && _ctx.sendDetected.kind === 'unknown')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_39, " Unrecognized destination — paste a Lightning invoice, Ark, or Bitcoin address. "))
                              : (_ctx.sendDetected.kind === 'lightning' && _ctx.sendDetected.amountSats === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, " Amountless invoices aren't supported — use one with a fixed amount. "))
                                : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.sendStatusText), 1),
                            _createElementVNode("button", {
                              class: "btn-outline btn-sm",
                              onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.resetSend && _ctx.resetSend(...args)))
                            }, "New Payment")
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'activity')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_43, [
                      (_ctx.txHistory.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [...(_cache[41] || (_cache[41] = [
                            _createElementVNode("div", { class: "empty-icon" }, "☀", -1),
                            _createElementVNode("div", { class: "empty-text" }, "No transactions yet", -1),
                            _createElementVNode("div", { class: "hint" }, "Your wallet activity will appear here", -1)
                          ]))]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.txHistory, (tx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: tx.txid + ':' + tx.createdAt,
                                class: "tx-row"
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["tx-dir", tx.type.toLowerCase()])
                                }, [
                                  (tx.type === 'RECEIVED')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_46, "▼"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_47, "▲"))
                                ], 2),
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("div", _hoisted_49, [
                                    _createElementVNode("span", _hoisted_50, [
                                      _createTextVNode(_toDisplayString(tx.type === 'RECEIVED' ? 'Received' : 'Sent') + " ", 1),
                                      (tx.isBoarding)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_51, "Boarding"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["tx-amount", tx.type.toLowerCase()])
                                    }, [
                                      _createTextVNode(_toDisplayString(tx.type === 'RECEIVED' ? '+' : '−') + _toDisplayString(Math.abs(tx.amount).toLocaleString()) + " ", 1),
                                      _cache[42] || (_cache[42] = _createElementVNode("span", { class: "tx-unit" }, "sats", -1))
                                    ], 2)
                                  ]),
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.formatRelative(tx.createdAt)), 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["tx-status", tx.settled ? 'settled' : 'pending'])
                                    }, _toDisplayString(tx.settled ? 'Settled' : 'Pending'), 3)
                                  ]),
                                  (tx.txid)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "tx-id mono",
                                        onClick: ($event: any) => (_ctx.copyText(tx.txid))
                                      }, _toDisplayString(tx.txid.slice(0, 12)) + "…" + _toDisplayString(tx.txid.slice(-8)), 9, _hoisted_54))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === 'settings')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_55, [
                      _createElementVNode("button", {
                        class: "btn-outline",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showKey = true))
                      }, "Back Up Private Key"),
                      _createElementVNode("button", {
                        class: "btn-outline",
                        disabled: _ctx.resyncing,
                        onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.resyncWallet && _ctx.resyncWallet(...args)))
                      }, _toDisplayString(_ctx.resyncing ? 'Resyncing…' : 'Resync Wallet Data'), 9, _hoisted_56),
                      _cache[44] || (_cache[44] = _createElementVNode("p", { class: "text-muted mono resync-hint" }, "Clears cached balance/VTXOs and re-syncs from the server. Keeps your key — use after a node/chain reset.", -1)),
                      _createElementVNode("button", {
                        class: "btn-danger",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showDeleteConfirm = true))
                      }, "Delete Wallet"),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", null, [
                          _createTextVNode("Network: " + _toDisplayString(_ctx.info?.network || '—') + " ", 1),
                          _cache[43] || (_cache[43] = _createElementVNode("span", { class: "net-note" }, "(set by server)", -1))
                        ]),
                        _createElementVNode("div", null, "Ark: " + _toDisplayString(_ctx.arkServer), 1),
                        _createElementVNode("div", null, "Status: " + _toDisplayString(_ctx.arkStatus), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.showKey)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "overlay",
                        onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.showKey = false), ["self"]))
                      }, [
                        _createElementVNode("div", _hoisted_58, [
                          _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "modal-title text-gold" }, "Private Key", -1)),
                          _cache[47] || (_cache[47] = _createElementVNode("p", { class: "modal-desc text-muted" }, "Never share this with anyone.", -1)),
                          _createElementVNode("div", {
                            class: "key-display",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.copyText(_ctx.privateKey)))
                          }, [
                            _createElementVNode("code", _hoisted_59, _toDisplayString(_ctx.privateKey), 1),
                            _cache[45] || (_cache[45] = _createElementVNode("span", { class: "address-action" }, "Click to copy", -1))
                          ]),
                          _createElementVNode("button", {
                            class: "btn-outline",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showKey = false))
                          }, "Close")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "fade" }, {
                default: _withCtx(() => [
                  (_ctx.showDeleteConfirm)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "overlay",
                        onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (_ctx.showDeleteConfirm = false), ["self"]))
                      }, [
                        _createElementVNode("div", _hoisted_60, [
                          _cache[48] || (_cache[48] = _createElementVNode("h3", { class: "modal-title text-red" }, "Delete Wallet", -1)),
                          _cache[49] || (_cache[49] = _createElementVNode("p", { class: "modal-desc text-muted" }, "This cannot be undone. Type DELETE to confirm.", -1)),
                          _withDirectives(_createElementVNode("input", {
                            class: "input",
                            type: "text",
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.deleteConfirmText) = $event)),
                            placeholder: "DELETE"
                          }, null, 512), [
                            [_vModelText, _ctx.deleteConfirmText]
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("button", {
                              class: "btn-outline",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showDeleteConfirm = false))
                            }, "Cancel"),
                            _createElementVNode("button", {
                              class: "btn-danger",
                              disabled: _ctx.deleteConfirmText !== 'DELETE',
                              onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.deleteWallet && _ctx.deleteWallet(...args)))
                            }, "Delete", 8, _hoisted_62)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_Transition, { name: "toast" }, {
                default: _withCtx(() => [
                  (_ctx.toastMsg)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["toast", _ctx.toastType])
                      }, _toDisplayString(_ctx.toastMsg), 3))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}